import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import { getAsset } from "../../helpers/helper";
import noImagePlaceholder from "../../assets/images/dummy/user-avatar-img.jpg";

const Reportreplymodal = ({ lgShow, setLgShow, title, singledata, isLoading }) => {
  const rawImg = (singledata?.data?.reply?.[0]?.imageUrl?.[0]) ||
    (singledata?.replies?.shopId?.image?.[0]) ||
    (singledata?.report?.serviceId?.images?.[0]);
  const avatarSrc = rawImg ? getAsset(rawImg) : noImagePlaceholder;

  return (
    <>
      <style>{`
        @keyframes pulse-skele {
          0% { opacity: 0.5; }
          50% { opacity: 1; }
          100% { opacity: 0.5; }
        }
        .pulsing-item {
          animation: pulse-skele 1.5s ease-in-out infinite;
        }
      `}</style>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <Row className="p-4 align-items-center pulsing-item">
              <Col lg="1" xs="2">
                <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#e9ecef" }} />
              </Col>
              <Col lg="11" xs="10" className="ps-0">
                <div style={{ width: "150px", height: "16px", backgroundColor: "#e9ecef", marginBottom: "8px", borderRadius: "4px" }} />
                <div style={{ width: "80px", height: "12px", backgroundColor: "#e9ecef", borderRadius: "4px" }} />
              </Col>
              <Col lg="12" className="mt-3 border p-3">
                <div style={{ width: "100%", height: "14px", backgroundColor: "#e9ecef", marginBottom: "8px", borderRadius: "4px" }} />
                <div style={{ width: "80%", height: "14px", backgroundColor: "#e9ecef", borderRadius: "4px" }} />
              </Col>
            </Row>
          ) : (
            <Row className="p-4">
              <Col lg="1" xs="2">
                <img
                  src={avatarSrc}
                  crossOrigin="anonymous"
                  className="pi-ck"
                  alt=""
                  onError={(ev) => {
                    ev.currentTarget.onerror = null;
                    ev.currentTarget.src = noImagePlaceholder;
                  }}
                  style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "50%" }}
                />
              </Col>
              <Col lg="11" xs="10" className="ps-0">
                <p className="font_15 mb-0">
                  <b>
                    {singledata?.data?.reply?.[0]?.role ||
                      singledata?.replies?.shopId?.shopname ||
                      singledata?.report?.serviceId?.profileName}
                  </b>
                </p>
                <p className="font_11">
                  {singledata?.replies?.shopId?._id ||
                    singledata?.data?.reply?.[0]?._id ||
                    singledata?.report?.serviceId?._id}
                </p>
              </Col>
              <Col lg="12" className="mt-3 border p-3">
                {singledata?.data?.reply?.[0]?.message ||
                  singledata?.replies?.reports?.[0]?.reply?.message ||
                  singledata?.report?.reports?.[0]?.reply?.message}
              </Col>
            </Row>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Reportreplymodal;
